<template>
  <div class="hero bg-secondary">
    <b-container>
      <h2 class="text-primary text-center">Latest News</h2>
      <b-row class="mt-5">
        <b-col cols="12" md="6" class="mt-2 mb-3 mb-md-2">
          <b-img-lazy
            class="news-image"
            alt=""
            src="../../assets/news/flowers.jpg"
          />
          <h3 class="my-3 text-primary"><b-link to="/news/winner-100th-trip">Winner of the 100th Trip!</b-link></h3>
          <p>
            Congratulations to Doreen and George from Thorney who were the lucky
            winners of the 100th Trip completed by the Car Scheme since our
            launch in April 2017.
          </p>
        </b-col>
        <b-col cols="12" md="6" class="mb-2 mt-3 mt-md-2">
          <b-img-lazy
            class="news-image"
            alt=""
            src="../../assets/news/th2.jpg"
          />
          <h3 class="my-3 text-primary"><b-link to="/news/could-you-be-our-100th-passenger">Could you be our 100th passenger?</b-link></h3>
          <p>
            The Scheme is gaining in popularity with a total of 37 passengers
            registered and using the service.
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "LatestNews",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.news-image {
  height: 231px;
  width: 100%;
  object-fit: cover;
}
a:link {
  color: inherit;
  background-color: transparent;
  text-decoration: none;
}

a:visited {
  color: inherit;
  background-color: transparent;
  text-decoration: none;
}

a:hover {
  color: #0a6e82;
  background-color: transparent;
  text-decoration: none;
}

a:active {
  color: #0a6e82;
  background-color: transparent;
  text-decoration: none;
}
</style>
